module.exports = __webpack_public_path__ + "img/qq-space.08fd4a9a.svg";